import styled from 'styled-components';

import Form, { IFormProps } from '@xcritical/forms';

import { ScrollbarStyle } from '@crm-framework/theme';

interface ILabelOption {
  tagColor: string;
  size: number;
}

export const LabelOption = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

export const LabelColor = styled.div<ILabelOption>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-radius: 50%;
  background-color: ${({ tagColor }) => tagColor};
  box-shadow: 2px 1px 3px 0.5px #515151a8;
`;

export const PhoneContainerEditView = styled.div`
  width: 100%;
  display: inline-grid;
  column-gap: 5px;
  grid-template-columns: 45px 45px calc(100% - 150px) 45px;
  max-height: 30px;
`;

export const StyledForm = styled<React.FC<IFormProps & { isGrid?: boolean }>>(
  Form
)`
  height: calc(100% - 80px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${({ isGrid }) => `${isGrid ? 0 : '10px'}`} 10px 0px
    ${({ isGrid }) => `${isGrid ? 0 : '10px'}`};

  ${ScrollbarStyle}
`;

export const LeadContent = styled.div<{ isHorizontal?: boolean }>`
  height: ${({ isHorizontal }) =>
    isHorizontal ? '500px' : 'calc(100% - 45px)'};
  overflow-x: hidden;
  overflow-y: auto;
  padding: ;
  padding: ${({ isHorizontal }) => (isHorizontal ? '0' : '0 5px')};

  ${ScrollbarStyle}
`;

export const ValueWrapper = styled.div`
  margin: auto 0;
  padding-left: 6px;
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  background: #fff;
`;

export const LeadShortHeaderTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

export const CenteredContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActionListItemWrapper = styled.div`
  position: relative;
`;

export const CountryWrapper = styled.div<{ withState?: boolean }>`
  ${({ withState }) =>
    withState
      ? `display: grid; gap: 5px; grid-template-columns: 50% 1fr;`
      : `width: 100%`}
`;
